import React, { useCallback, useState } from "react"
import cn from "classnames"
import { graphql } from "@/api"
import { useMutation } from "@apollo/client"
import Checkbox from "./checkbox"
import { useFeatureIsOn } from "../growthbook-react"

const enableDoc = graphql(`
  mutation EnableAddToCartUpdate($id: Int!) {
    enableAddToCartUpdate(id: $id) {
      enabled
    }
  }
`)

export interface EnableAddToCartProps {
  signId: number
  enabled: boolean
  hangTypeBlank: boolean
}

const EnableAddToCart: React.FC<EnableAddToCartProps> = ({ signId, enabled, hangTypeBlank }) => {
  const [isEnabled, setIsEnabled] = useState(enabled)
  const [enableAddToCartUpdate, enableAddToCartUpdateResult] = useMutation(enableDoc, {
    update: (store, { data }) => {
      if (data?.enableAddToCartUpdate?.enabled === false) {
        setIsEnabled(false)
      } else if (data?.enableAddToCartUpdate?.enabled === true) {
        setIsEnabled(true)
      } else {
        setIsEnabled(enabled)
      }
    },
  })

  const handleClick = useCallback(() => {
    enableAddToCartUpdate({ variables: { id: signId } })
  }, [signId, enableAddToCartUpdate])

  const loading = enableAddToCartUpdateResult?.loading
  const newExamplesComponentFlag = useFeatureIsOn("new-component-for-examples")

  return (
    <div className={cn("flex items-center", { disabled: hangTypeBlank })}>
      {newExamplesComponentFlag ? (
        <>
          <Checkbox
            id={`enable_add_to_cart_${signId}`}
            name={`enable_add_to_cart_${signId}`}
            disabled={loading || hangTypeBlank}
            checked={isEnabled}
            label="Cart"
            onChange={handleClick}
            labelClassName="mt-1"
          />

          <div className="tooltip invisible absolute -ml-20 mb-20 rounded p-1 text-center font-semibold text-ink-100">
            Sign needs fixing method before cart can be enabled
          </div>
        </>
      ) : (
        <>
          <input
            id={`enable_add_to_cart_${signId}`}
            className="enable-add-to-cart datasync mr-1 cursor-pointer appearance-none"
            type="checkbox"
            onChange={handleClick}
            disabled={loading || hangTypeBlank}
            checked={isEnabled}
          />
          <div className="tooltip invisible absolute -ml-20 mb-20 rounded p-1 text-center font-semibold text-ink-100">
            Sign needs fixing method before cart can be enabled
          </div>
          <label className="paragraph-sm !mb-0 cursor-pointer" htmlFor={`enable_add_to_cart_${signId}`}>
            Cart
          </label>
        </>
      )}
    </div>
  )
}

export default EnableAddToCart
